module.exports = __webpack_public_path__ + "img/11.4463777f.jpg";